import { GetTenantByNameDocument } from '@graphql/generated/graphql';

import { APIService } from '@services/ApiService';
import { AuthService } from '@services/AuthService/AuthService';

import { useLazyQuery } from '@apollo/client';

export const useFindCompanyByName = () => {
    return useLazyQuery(GetTenantByNameDocument, {
        context: {
            globalUrl: true,
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: (payload) => {
            AuthService.setTenantUuid(payload.tenant[0].uuid);
            new APIService().setGraphAPI = payload?.tenant?.[0]?.apiUrl;
        },
    });
};
